class Product3D {
    constructor(product) {
        this.product = product
        this.colors = null
        this.init()
    }

    init() {
        this.getColors()
        this.addEventListeners()
        if(document.querySelector('.shopify-section.product-3d .color-controls .button-group .button-3d') !== null) {
          document.querySelector('.shopify-section.product-3d .color-controls .button-group .button-3d').dispatchEvent(new Event('click')) //Trigger color event for first item
        }
    }

    addEventListeners() {
        let self = this
        const buttons = document.querySelectorAll('.shopify-section.product-3d .button-3d')

        buttons.forEach((button) => {
            button.addEventListener('click', (e) => {
                e.preventDefault()
                e.stopPropagation()

                // Skip if the button is already active
                if (button.classList.contains('active') || button.classList.contains('disabled')) {
                   return 
                }

                if(button.dataset.hasOwnProperty('function') && button.dataset.function === 'activate' && charpstAR.qrCodeModalActive ) {
                    return
                }

                if(button.dataset.hasOwnProperty('function') && button.dataset.function !== '') {
                    if(button.dataset.hasOwnProperty('value') && button.dataset.value !== '') {
                        charpstAR[button.dataset.function](button.dataset.value)
                    } else {
                        charpstAR[button.dataset.function]()
                    }
                    
                }

                const siblingButtons = button.parentNode.querySelectorAll('.button-3d')
                const isControlClicked = button.closest('.option-section').classList.contains('view-controls') ? true : false


                // Skip if there's only one button in the parent container
                if (siblingButtons.length === 1) {
                    return
                }

                // Remove 'active' class from all sibling buttons
                siblingButtons.forEach((btn) => {
                  btn.classList.remove('active')
                  if(isControlClicked && !btn.isEqualNode(button)) {
                    btn.classList.add('disabled')
                  }
                })

                // Add 'active' class to the clicked button
                if(button.closest('.option-section').classList.contains('color-controls')) {
                    button.closest('.option-section').querySelector('.selected-color').innerHTML = self.insertSpaces(button.dataset.value)
                } 
                button.classList.add('active')
                window.setTimeout(function() {
                  if(isControlClicked && charpstAR.isAnimating) {
                    self.waitForVariableAndRemoveClass(document.querySelectorAll('.shopify-section.product-3d .view-controls .button-3d:not(.active)'))
                  }
                }, 50)
                
            });
        });
    }


    getColors = () => {
        let self = this
        self.colors = {
            'white': 'url(https://cdn.shopify.com/s/files/1/2790/5062/files/bcr_3d_white.jpg)',
            'black': 'url(https://cdn.shopify.com/s/files/1/2790/5062/files/bcr_3d_black.jpg)',
            'blacknatural': 'url(https://cdn.shopify.com/s/files/1/2790/5062/files/bcr_3d_black_natural.jpg)',
            'ash': 'url(https://cdn.shopify.com/s/files/1/2790/5062/files/bcr_3d_ash.jpg)',
            'teak': 'url(https://cdn.shopify.com/s/files/1/2790/5062/files/bcr_3d_teak.jpg)',
            'natural': 'url(https://cdn.shopify.com/s/files/1/2790/5062/files/bcr_3d_natural.jpg)',
            'thermowood': 'url(https://cdn.shopify.com/s/files/1/2790/5062/files/bcr_3d_thermowood.jpg)',
            'cedar': 'url(https://cdn.shopify.com/s/files/1/2790/5062/files/bcr_3d_cedar.jpg)',
            'blackwood': 'url(https://cdn.shopify.com/s/files/1/2790/5062/files/bcr_3d_black_wood.jpg)',
            //'': '',
        }

        if(charpstAR.getAvailableColors().length === 0) {
          document.querySelector('.shopify-section.product-3d .color-controls').innerHTML = ''
            document.querySelector('.shopify-section.product-3d .color-controls').style.display = 'none'
            return
        }

        let colorHtml = ''
        charpstAR.getAvailableColors().forEach((color) => {
            let lowerCaseColor = color.toLowerCase()
            if (lowerCaseColor in self.colors) {
                if(lowerCaseColor === 'white') {
                    colorHtml += '<button title="' + self.insertSpaces(color) + '" class="button-3d" style="background-image: ' + self.colors[lowerCaseColor] + '" data-function="changeColor" data-value="' + color + '"></button>'
                } else {
                    colorHtml += '<button title="' + self.insertSpaces(color) + '" class="button-3d" style="background-image: ' + self.colors[lowerCaseColor] + '" data-function="changeColor" data-value="' + color + '"></button>'
                }
            } else {
              colorHtml += '<button title="' + self.insertSpaces(color) + '" class="button-3d" style="border: 1px solid #000; background: transparent" data-function="changeColor" data-value="' + color + '"></button>'
            }
        })
        document.querySelector('.shopify-section.product-3d .color-controls .button-group').innerHTML = colorHtml
      document.querySelector('.shopify-section.product-3d .color-controls').style.display = ''
    }

    insertSpaces = (string) => {
        string = string.replace(/([a-z])([A-Z])/g, '$1 $2');
        string = string.replace(/([A-Z])([A-Z][a-z])/g, '$1 $2')
        return string;
    }

    waitForVariableAndRemoveClass = (elements, interval = 10) => {
        return new Promise((resolve) => {
            const checkVariable = () => {
                if (!charpstAR.isAnimating) {
                    elements.forEach((btn) => {
                        btn.classList.remove('disabled')
                    })
                    resolve();
                } else {
                    setTimeout(checkVariable, interval);
                }
            };
            checkVariable();
        });
    }
}